import { Route, Switch, withRouter } from "react-router-dom";
import { PrivateRoute } from './PrivateRoute';
import { connect } from 'react-redux';
import { Login } from '../Auth0/Login';
import { mapStateToPropsInitial, mapDispatchToProps, IProps } from './Routes';
import React from "react";
import { Guest } from "../../scenes/public/Guest";

const comp = (props: IProps) => {
    return (<Switch>
        <Route path="/login" exact render={p => <Login {...p} {...props} />} />
        <Route path="/public" render={p => <Guest  {...p} {...props} />} />
        <PrivateRoute path="/" render={p => React.Children.only(props.children)} />
    </Switch>);
}
export const InitialRoutes = connect(mapStateToPropsInitial, mapDispatchToProps)(withRouter(comp))